import {Component, Input} from '@angular/core';
import {type TileInfo} from '@models/tile-info';
import {FlexModule} from '@ngbracket/ngx-layout';
import {GenericTileComponent} from '../generic-tile/generic-tile.component';

@Component({
  selector: 'app-generic-tile-list',
  imports: [GenericTileComponent, FlexModule],
  templateUrl: './generic-tile-list.component.html',
  styleUrl: './generic-tile-list.component.scss',
})
export class GenericTileListComponent {
  @Input() tiles: TileInfo[] = [];
}
